import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../icon';
import Text from '../../type/text';
import { marginClassNamePropType } from '../../__utils/spacingClassNamePropType';

import './style.scss';

const Note = ({ type, size, children, className, qaId }) => {
  const noteClasses = classNames('uni-note', {
    [`uni-note--${type}`]: type,
    [`uni-note--${size}`]: size,
    [className]: className,
  });

  let textSize;
  if (size === 'small') {
    textSize = 'micro';
  } else if (size === 'medium') {
    textSize = 'default';
  } else {
    textSize = 'large';
  }

  return (
    <div className={noteClasses} data-qa-id={qaId}>
      <Icon size={size} type={type === 'success' ? 'confirmation' : type} />
      <Text level={textSize}>{children}</Text>
    </div>
  );
};

Note.propTypes = {
  type: PropTypes.oneOf(['information', 'warning', 'critical', 'confirmation']).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node.isRequired,
  className: marginClassNamePropType,
  qaId: PropTypes.string,
};

Note.defaultProps = {
  type: 'information',
  size: 'medium',
};

export default Note;



// WEBPACK FOOTER //
// ./src/notifications/note/index.jsx